module.exports = { src: __webpack_public_path__ + "media/rentals-logo.7408c40b.svg", width: 215, height: 25 };